const updatePager = (url, data, updateContentCallback, option) => {
  const prevButton = document.querySelector(".page--prev button");
  const nextButton = document.querySelector(".page--next button");
  const currentPage = document.querySelector(".page--current");
  const wholePage = document.querySelector(".page--whole");

  currentPage.textContent = data.current_page;
  wholePage.textContent = data.last_page;

  if (data.prev_page_url) {
    updateButton(prevButton, false);
    prevButton.onclick = () =>
      fetchAndRenderPage(
        url,
        data.current_page - 1,
        updateContentCallback,
        option
      );
  } else {
    updateButton(prevButton, true);
  }

  if (data.next_page_url) {
    updateButton(nextButton, false);
    nextButton.onclick = () =>
      fetchAndRenderPage(
        url,
        data.current_page + 1,
        updateContentCallback,
        option
      );
  } else {
    updateButton(nextButton, true);
  }
};

const updateButton = (button, disabled) => {
  button.disabled = disabled;
  const activeImg = button.querySelector("img.active");
  const inactiveImg = button.querySelector("img.inactive");
  inactiveImg.style.cursor = "initial";
  if (disabled) {
    activeImg.style.display = "none";
    inactiveImg.style.display = "block";
  } else {
    activeImg.style.display = "block";
    inactiveImg.style.display = "none";
  }
};

const fetchPaginationData = (url, page, updateContentCallback, option) => {
  return fetchWithHandling(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      page: page,
      ...option,
    }),
  }).then((data) => {
    updatePager(url, data, updateContentCallback, option);
    return data;
  });
};

const fetchAndRenderPage = (url, page, updateContentCallback, option) => {
  return fetchPaginationData(url, page, updateContentCallback, option)
    .then((data) => {
      updatePager(url, data, updateContentCallback, option);
      updateContentCallback(data);
      return data;
    })
    .catch((error) => console.error("Error:", error));
};

{
  /* <ul class="mypage--content--kiroku--form--pager">
    <li class="page--prev"><button class="fc--mypage--orange--normal fw_bold"><img src="{{ 'mypage--arrow--circled.svg' | asset_url }}" alt=""></button></li>
    <li class="fc--mypage--orange--normal fw_bold">PAGE</li>
    <li class="page--current fc--mypage--orange--normal fw_bold">1</li>
    <li class="fc--mypage--orange--normal fw_bold">/</li>
    <li class="page--whole fc--mypage--orange--normal fw_bold">1</li>
    <li class="page--next"><button class="fc--mypage--orange--normal fw_bold"><img src="{{ 'mypage--arrow--circled.svg' | asset_url }}" alt=""></button></li>
</ul> */
}

/**
 * ネットワークリクエストを送信し、レスポンスをJSONとして解析するラッパー関数。
 * @param {string} url - リクエストするURL。
 * @param {object} [options] - fetch関数に渡すオプションオブジェクト。
 * @return {Promise} レスポンスの解析されたJSONまたはエラーオブジェクトを含むプロミス。
 */
const fetchWithHandling = (url, options = {}) => {
  return fetch(url, options)
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw {
            status: response.status,
            statusText: response.statusText,
            error: errorData,
          };
        });
      }
      return response.json();
    })
    .catch((error) => {
      console.log(error);
      let errorMessage = "";
      // エラーレスポンスからバリデーションメッセージを抽出
      if (error.error && error.error.error) {
        // サーバーからのバリデーションメッセージ
        errorMessage = error.error.error;
      } else if (error.error && error.error.errors) {
        // サーバーからのバリデーションエラーメッセージ
        const errors = error.error.errors;
        errorMessage = Object.keys(errors)
          .map((key) => errors[key].join("\n"))
          .join("\n");
      } else if (error.statusText) {
        // HTTPステータステキストがある場合はそれを使用
        errorMessage = error.statusText;
      }

      if (errorMessage) {
        alert(errorMessage);
      }
      throw error;
    });
};
